var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WebOffice',{attrs:{"officeType":_vm.officeType,"fileId":_vm.fileId,"userId":_vm.userId,"currentVersion":_vm.currentVersion,"editType":_vm.editType,"knowledgeDetail":_vm.knowledgeDetail,"previousVersion":_vm.previousVersion},on:{"updatePreviousVersion":_vm.updatePreviousVersion}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }